var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-page sub-page-leftmenu"},[_c('div',{staticClass:"sub-content"},[_c('GroupByResultComponent',{attrs:{"option":"consultant"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }